export default __webpack_public_path__ + "static/media/MuseoSans_500-webfont.a1e6da60.ttf";